export default __webpack_public_path__ + "assets/fonts/489553df26d66b9ac8058b42dda883f9.woff2";